import { createTracker, newSessionId } from 'uhs-finder.metrics';
import { initRequestForm, subscribeReturn } from 'uhs-request.form';
import { loadPayload } from 'uhs-finder.payload';



let openListener = null;

export function initRequest(root) {
  const dialog = root.querySelector('[data-uhs-request-dialog]');
  const sessionId = subscribeReturn()?.sessionId || newSessionId();
  const d = root.dataset;

  const openDialog = () => {
    if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
  };



  const track = createTracker(d.metricsUrl || '', sessionId);
  const form = initRequestForm(root, {
    sessionId,
    track: (event, fields) => track(event, { source: 'product', ...fields }),
    copy: {
      requestUrl: d.requestUrl || '/apps/uhs/finder-request',
      requestSuccess: d.requestSuccess || 'Got it - thanks.',
      requestError: d.requestError || "That didn't send. Please try again.",
      requestThrottled: d.requestThrottled || "You've already sent us a few. Try again later.",
      requestEmailInvalid: d.requestEmailInvalid || "That email doesn't look right. Fix it or clear it.",
      requestSuccessSubscribed: d.requestSuccessSubscribed || "Request sent - and you're on the list.",
      requestSuggestions: d.requestSuggestions || 'Is it one of these?',

      requestSuggestionsNote: d.requestSuggestionsNote ?? "These are close matches to what you typed. Check the model name before you order. Either way, we've got your request.",
      leadTimeMade: d.leadTimeMade || '',
      soldOut: d.soldOutNote || 'Sold out right now - check back soon.',
    },
    payload: () => loadPayload(d.sectionUrl),
    context: () => ({ source: 'product' }),
    show: openDialog,
  });
  if (!form) return;

  if (openListener) document.removeEventListener('click', openListener);

  openListener = event => {
    if (!event.target.closest?.('[data-uhs-request-open]')) return;


    if (!root.isConnected) return;
    form.open();
  };

  document.addEventListener('click', openListener);
}

function boot(scope) {
  const root = scope.querySelector('[data-uhs-request]');
  if (!root) return;

  try {
    initRequest(root);
  } catch (err) {
    console.error('UHS request init failed:', err);
  }
}


boot(document);

document.addEventListener('shopify:section:load', event => {
  if (event.target && typeof event.target.querySelector === 'function') boot(event.target);
});
